import React from "react";

const ItemBoxList = ({ items }) => {
  const boxContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    padding: "10px",
  };

  const boxStyle = {
    padding: "3px 3px",
    backgroundColor: "#e0f7fa",
    border: "1px solid #00acc1",
    borderRadius: "8px",
    fontSize: "0.7rem",
    // fontWeight: 'bold'
  };

  return (
    <div style={boxContainerStyle}>
      {items.map((item, index) => (
        <div key={index} style={boxStyle}>
          {item}
        </div>
      ))}
    </div>
  );
};

export default ItemBoxList;
